module.exports = __webpack_public_path__ + "img/badge_parchi.0f33ccff.jpg";